import { render, staticRenderFns } from "./PlayerFeature.vue?vue&type=template&id=3480e853&scoped=true&"
import script from "./PlayerFeature.vue?vue&type=script&lang=js&"
export * from "./PlayerFeature.vue?vue&type=script&lang=js&"
import style0 from "./PlayerFeature.vue?vue&type=style&index=0&id=3480e853&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480e853",
  null
  
)

export default component.exports